import React from "react";
import { useSelector } from "react-redux";
import ERPSyncEnable from "./homepage/ERPSyncEnable";
import ERPSyncActive from "./homepage/ERPSyncActive";
import ERPSyncDisable from "./homepage/ERPSyncDisable";

const ERPSync = () => {
  const ERPSyncStatus = useSelector((state) => state.home.ERPSyncStatus);

  return (
    <>
      {ERPSyncStatus === 0 ? (
        <ERPSyncEnable />
      ) : ERPSyncStatus === 1 ? (
        <ERPSyncActive />
      ) : (
        <ERPSyncDisable />
      )}
    </>
  );
};

export default ERPSync;
